import React from 'react';
import InlineLoading from './InlineLoading';

const ClientQuotationCategoriesPanel = ({
  categoryOptions = [],
  selectedCategoryIds,
  loading = false,
  saving = false,
  error = '',
  disabled = false,
  title = 'Categorias para ordenes',
  description = 'Controla que categorias puede ver este cliente al crear ordenes de compra.',
  emptyWarning = 'Sin categorias seleccionadas: este cliente vera vacio el catalogo de ordenes de compra.',
  onToggle,
}) => {
  const selectedCount = selectedCategoryIds?.size || 0;

  return (
    <div className="border-t border-gray-100 pt-4 space-y-3">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-2">
        <div>
          <h2 className="text-sm font-semibold text-gray-700">{title}</h2>
          <p className="text-xs text-gray-500">
            {description}
          </p>
        </div>
        <span className="text-xs text-gray-500">{selectedCount} seleccionadas</span>
      </div>

      {loading ? (
        <InlineLoading label="Cargando categorias" />
      ) : error ? (
        <p className="text-xs text-red-600">{error}</p>
      ) : categoryOptions.length ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {categoryOptions.map((category) => (
            <label
              key={category.id}
              className="flex items-center gap-2 rounded border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700"
            >
              <input
                type="checkbox"
                checked={selectedCategoryIds?.has(String(category.id)) || false}
                onChange={() => onToggle?.(category.id)}
                disabled={disabled || saving}
              />
              <span>{category.name}</span>
            </label>
          ))}
        </div>
      ) : (
        <p className="text-xs text-gray-500">No hay categorias activas disponibles.</p>
      )}

      {!selectedCount && !loading && !error && (
        <p className="text-xs text-amber-700 bg-amber-50 border border-amber-100 rounded px-3 py-2">
          {emptyWarning}
        </p>
      )}
    </div>
  );
};

export default ClientQuotationCategoriesPanel;
